import BaseClient from '@/app/model/api/response/baseApiClient'

class FieldOrderEditApi extends BaseClient {
  public doUpdateStatus (plantingId: number, bodyData: any) {
    const path = '/v1/field/order/' + plantingId

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new FieldOrderEditApi()
